

import React, { useState, useRef, useEffect } from 'react';
import './GetAppPage.css';


const googlePlayBadgeUrl = 'https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg';
const androidLogoUrl = 'https://upload.wikimedia.org/wikipedia/commons/d/d7/Android_robot.svg';
const appleLogoUrl = 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg';

const GetAppPage = () => {
  const [activePlatform, setActivePlatform] = useState('android');

  const androidBtnRef = useRef(null);
  const iosBtnRef = useRef(null);
  const [switcherStyle, setSwitcherStyle] = useState({});

  useEffect(() => {
    const activeBtn = activePlatform === 'android' ? androidBtnRef.current : iosBtnRef.current;
    if (activeBtn) {
      setSwitcherStyle({
        width: `${activeBtn.offsetWidth}px`,
        transform: `translateX(${activeBtn.offsetLeft}px)`,
      });
    }
  }, [activePlatform]);

  return (
    <div className="premium-get-app-page">
      <div className="app-showcase">
        <div className="phone-perspective-container">
          <div className="phone-mockup">
            <div className="phone-frame">
              <div className="phone-screen">
                <div
                  className={`phone-screen-background-shimmer ${
                    activePlatform === 'android' ? 'android-bg' : 'ios-bg'
                  }`}
                ></div>
                
                <div
                  className={`phone-app-icon-container ${
                    activePlatform === 'android' ? 'android-icon-bg' : 'ios-icon-bg'
                  }`}
                  key={activePlatform} 
                >
                  <img
                    src={activePlatform === 'android' ? androidLogoUrl : appleLogoUrl}
                    alt={`${activePlatform} platform logo`}
                    className="phone-app-icon"
                  />
                </div>

                <div className="phone-screen-notch"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="app-details">
          <h1 className="details-title">Your Gateway to Community Commerce</h1>
          <p className="details-description">
            Seamlessly integrated into your life. The Vanidya experience, now in your pocket. Choose your platform below.
          </p>

          <div className="platform-switcher">
            <div className="switcher-background" style={switcherStyle}></div>
            <button
              ref={androidBtnRef}
              className={`switcher-btn ${activePlatform === 'android' ? 'active' : ''}`}
              onClick={() => setActivePlatform('android')}
              aria-pressed={activePlatform === 'android'}
            >
              Android
            </button>
            <button
              ref={iosBtnRef}
              className={`switcher-btn ${activePlatform === 'ios' ? 'active' : ''}`}
              onClick={() => setActivePlatform('ios')}
              aria-pressed={activePlatform === 'ios'}
            >
              iOS
            </button>
          </div>

          <div className="app-content-wrapper">
            <div className={`app-content ${activePlatform === 'android' ? 'active' : ''}`}>
              <h2 className="content-title">Available on Google Play</h2>
              <p className="content-description">
                Optimized for Android devices to provide a smooth and intuitive experience. Download today and join the community.
              </p>
              <a href="https://play.google.com/store/apps" target="_blank" rel="noopener noreferrer">
                <img src={googlePlayBadgeUrl} alt="Get it on Google Play" className="google-play-badge" />
              </a>
            </div>
            <div className={`app-content ${activePlatform === 'ios' ? 'active' : ''}`}>
              <h2 className="content-title">Coming Soon to the App Store</h2>
              <p className="content-description">
                Our team is putting the final touches on a beautifully crafted iOS app. We appreciate your patience and excitement!
              </p>
              <div className="coming-soon-badge">
                Launching Soon
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetAppPage;